import React, { Component } from 'react';
import { Cell, Grid } from 'react-md';
import { browserHistory } from 'react-router';
import ApiRequestService from '../component/ApiRequestService';
//import SectionDashboardBarChart from '../component/sectionDashboardBarChart';
import BarChart from '../component/BarChartCustom';
import ButtonDashboard from '../component/ButtonDashboard';
import LoadingSpinner from '../component/LoadingSpinner';
import QuizListWidget from '../component/QuizListWidget';
import '../css/Dashboard.css';
import styles from '../css/styles.css.js';
import { AppProperties } from '../common/function';
import CreateNewAssignment from './CreateNewAssignment.js';



const pad = (num) =>  {
  return ("0"+num).slice(-2);
}

const hhmmss =  (secs) => {
var minutes = Math.floor(secs / 60);
secs = secs%60;
var hours = Math.floor(minutes/60)
minutes = minutes%60;
return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
}

/* const scoreRangeLabel = (tooltipItem, data) => {
  
  var label = data.datasets[tooltipItem.datasetIndex].label || '';

  if (label) {
      label += ': ';
  }
  label += Math.round(tooltipItem.yLabel * 100) / 100;

  return "Student count : " + label;
} */


const getComletionTimeLabel = (tooltipItem, data) => {
  var label = tooltipItem?.label;
  if (data && data.datasets) {
    label = data.datasets[tooltipItem.datasetIndex].label || '';
  }

  if (label) {
      label += ': ';
  }
  label += Math.round(tooltipItem.yLabel * 100) / 100;

  return "Avg Completion Time : " + hhmmss(label);
}


const getCompletionPercentLabel = (tooltipItem, data) => {
  var label = tooltipItem?.label;

  if (label) {
      label += ': ';
  }
  label += Math.round(tooltipItem.raw * 100) / 100;

  return "Completion Percentage :"+label;
}


const buildGraphData = (res,valueName) =>{
  let quizLabel = [];
  let quizData = [];
  if(res !== undefined && res !== null && 
    res.data !== undefined &&  res.data !== null &&
    res.data.data !== undefined &&  res.data.data !== null &&
    res.data.data.course_quiz_percentage !== undefined &&  
    res.data.data.course_quiz_percentage !== null){

      var tempCourseDetails = res.data.data.course_quiz_percentage;
      
      for(var i = 0; i < tempCourseDetails.length;i++ ){
        quizLabel.push(tempCourseDetails[i].quiz_name);
        quizData.push(tempCourseDetails[i][valueName]);
      }

      return {'label':quizLabel,'data':quizData};
  }

  return null;
}

export default class SectionsDashboard extends Component {
  appProperties = AppProperties();
  baseFolder = this.appProperties.baseFolder;
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      graphData:null,
      editAssignmentMode: false,
      editAssignment: null,
      savedAssignment: null,
      
    };
    this.createQuizSelect = this.createQuizSelect.bind(this);
  }
  //http://localhost:3000/quizScore?qname=test%20vector&static=0&class=test%20class

  addBreadCrumbs = () => {
    console.debug('Sections AddBreadCrumbs');
    this.props.replaceBreadCrumb([
      {
        name: this.props.location.query.course_name,
        type: (this.appProperties.schoolMode?'Standards':'Courses'),
        onclickPath: 'CoursesDashboard?course_indx=' + this.props.location.query.course_indx
      },
      {
        name: this.props.location.query.section_name,
        type: 'Section',
        onclickPath:
          'sectionsDashboard?section_id=' +
          this.props.location.query.section_id +
          '&course_id=' +
          this.props.location.query.course_id +
          '&course_name=' +
          this.props.location.query.course_name +
          '&section_name=' +
          this.props.location.query.section_name +
          '&course_indx=' + this.props.location.query.course_indx
      }
    ]);
  };

  //API Call to Get Course Data
  getGraphData = (courseID,sectionID) =>{

    this.setState({loadingGraph:true});
    let parent = this;
    
    const payload = {
      course_id: parseInt(courseID, 10),
      section_id:parseInt(sectionID, 10)
    };

    return  new Promise((resolve, reject) =>  {
      
      let promises = [];
      promises.push(ApiRequestService({
                                    method: 'post',
                                    url: '/getSectionGraph',
                                    data: payload
                                  }));

      promises.push(ApiRequestService({
                                            method: 'post',
                                            url: '/getSectionMedianGraph',
                                            data: payload
                                        }));

      Promise.all(promises).then(results =>{

        let getCourseGraphResp        = buildGraphData(results[0],'quiz_percentage');
        let getCourseMedianGraphResp  = buildGraphData(results[1],'quiz_median_time');

        resolve({'attemptPercentage':getCourseGraphResp,'medianData':getCourseMedianGraphResp});
      }).catch(function(err) {
        reject(err);
      }).finally(function(){
        parent.setState({loadingGraph:false});
      });


      
    });
  }
  async componentWillMount() {
    let graphDataObject = await this.getGraphData( this.props.location.query.course_id,this.props.location.query.section_id );

    this.setState({
      graphData:graphDataObject
    });  
  }

  componentWillUpdate() {
    this.addBreadCrumbs();
    
  }

  onScoreButtonClick = quizData => {
    console.debug('quizData' + JSON.stringify(quizData));
    var pageName = "quizScore";
    if(quizData.quiz_type === 1){
      pageName = "testScore";
    }
    browserHistory.push(
      this.baseFolder +
      pageName + '?qname=' +
        quizData.quiz_name +
        '&static=0&course_name=' +
        this.props.location.query.course_name+
        '&quiz_id=' +
        quizData.quiz_id +
        '&course_indx=' + this.props.location.query.course_indx+
        '&course_id=' +
        quizData.course_id +
        '&section_id=' +
        this.props.location.query.section_id
    );
  };
  createQuizSelect(sectionID) {
    browserHistory.push(
      this.baseFolder +
        'QuizCreation?course_id=' +
        this.props.location.query.course_id +
        '&section_id=' +
        this.props.location.query.section_id +
        '&course_name=' +
        this.props.location.query.course_name +
        '&section_name=' +
        this.props.location.query.section_name +
        '&sectionDashboard=true' +
        '&course_indx=' + this.props.location.query.course_indx +
        '&is_lti_enabled=' + this.props.location.query.is_lti_enabled
    );
  }

  onQuizEditClick(quizObject) {
    //QuizCreation?course_id=8&section_id=16&quiz_id=558&course_name=course%20test%20102&section_name=Phy%20seesntial%20section%20101-%20fall%202018
    console.debug('quizObject' + quizObject);
    console.debug('quizObject = ' + quizObject['quiz_id']);

    // this.setState({ editAssignmentMode: true, editAssignment: quizObject });
    browserHistory.push(
      this.baseFolder +
        'QuizCreation?course_id=' +
        this.props.location.query.course_id +
        '&section_id=' +
        this.props.location.query.section_id +
        '&quiz_id=' +
        quizObject['quiz_id'] +
        '&course_name=' +
        this.props.location.query.course_name +
        '&section_name=' +
        this.props.location.query.section_name +
        '&sectionDashboard=true'+
        '&course_indx=' + this.props.location.query.course_indx + 
        '&is_lti_enabled=' + this.props.location.query.is_lti_enabled
    );
  }

  onQuizEditClose = () => {
    this.setState({ editAssignmentMode: false, editAssignment: null });
  }

  onSaveAssignment = (savedAssignment) => {
    this.setState({
      savedAssignment,
    })
  }

  render() {
    if (this.state.loading) return <LoadingSpinner loading={this.state.loading} />;

    let courseWidgets = (
      <React.Fragment>
          <Cell size={6} className="cellBarChart">
            {this.state.graphData !== null ?
            <BarChart loading={this.state.loadingGraph} 
            getBarLabel={getCompletionPercentLabel} 
            graphTitleClass="graphTitleStyle" title="Assignment Completion Percentage" data={this.state.graphData.attemptPercentage.data}  
            label={this.state.graphData.attemptPercentage.label}  />
            :
            null}
            
          </Cell>
          <Cell size={6} className="cellBarChart">
            {this.state.graphData !== null ?
            <BarChart loading={this.state.loadingGraph} 
            labelFormatter={hhmmss} getBarLabel={getComletionTimeLabel}
            graphTitleClass="graphTitleStyle" title="Average Completion Time"  data={this.state.graphData.medianData.data}  
            label={this.state.graphData.medianData.label}  />
            :
            null}
            
          </Cell>
      </React.Fragment>
    );
      let quizListWidgets = (
        <Cell size={12} phoneSize={12} className="noHorizondalPadding dataBox">
          <QuizListWidget
            onQuizEditClick={this.onQuizEditClick.bind(this)}
            onClick={this.onScoreButtonClick}
            section_id={this.props.location.query.section_id}
            course_id={this.props.location.query.course_id}
            is_lti_enabled={this.props.location.query.is_lti_enabled === 'true'}
            defaultRowsPerPage={20}
            title="Assignment List"
            savedAssignment={this.state.savedAssignment}
          />
        </Cell>
   
    );

    let courseBody = (
      <Grid gutter={1}>
        {/* <Cell className="DashboardButtonContainer" size={4} phoneSize={12}><ButtonDashboard icon={faFile} >Create New Class</ButtonDashboard></Cell> */}
        <Cell
          className="DashboardButtonContainer"
          style={{ marginTop: '39px', marginLeft: '16px' }}
          size={3}
          phoneSize={4}
        >
          {/* <CreateNewAssignment 
            selectedCourse={{
              course_id: parseInt(this.props.location.query.course_id, 10),
            }}
              editAssignmentMode={this.state.editAssignmentMode}
              editAssignmentData={this.state.editAssignment}

              onSaveAssignment={this.onSaveAssignment}
              onQuizEditClose={this.onQuizEditClose}
          /> */}
          <ButtonDashboard
            onCreateQuizSelect={this.createQuizSelect}
            icon="calendar_today"
          >
            Create New Assignment
          </ButtonDashboard>
        </Cell>
        {/* <Cell className="DashboardButtonContainer" size={4} phoneSize={12}><ButtonDashboard  icon={faCog} >Get Help</ButtonDashboard></Cell> */}
        {this.props.location.query.course_id ? 
          <Grid gutter={1} >
            {courseWidgets}
            {quizListWidgets}
          </Grid> 
        : ''}
      </Grid>
    );

    return (
      <div>
        <div style={styles.sectionDashboardTitle}>
          <h1>Section - {this.props.location.query.section_name}</h1><br/>
        </div>
        {this.props.location.query.course_id ? courseBody : ''}
      </div>
    );
  }
}
